export default __webpack_public_path__ + "static/media/onlineIconCircle.88361f7c.svg";